import Vue from "vue";
import axios from "axios";
import CryptoJS from "crypto-js";
export default {
  randomString(len) {
    len = len || 32;
    var $chars =
      "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    var maxPos = $chars.length;
    var pwd = "";
    for (let i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  },
  changeImageSize(className) {
    var _this = this;
    //_this.$nextTick(function () {
    // 获取所有的img标签
    let imgList = document.querySelectorAll("." + className);
    for (let i = 0; i < imgList.length; i++) {
      const element = imgList[i];
      //获取父元素宽高
      let parentWh = element.parentNode;
      let wid = this.getWidHei(parentWh, "width");
      let hei = this.getWidHei(parentWh, "height");
      element.onload = function() {
        var self = this;
        // 等比压缩图片
        _this.AutoResizeImage(self, wid, hei);
      };
    }
    //})
  },
  AutoResizeImage(objImg, maxWidth, maxHeight) {
    var img = new Image();
    img.src = objImg.src;
    var hRatio;
    var wRatio;
    var Ratio = 1;
    var w = img.width;
    var h = img.height;
    wRatio = maxWidth / w;
    hRatio = maxHeight / h;
    if (maxWidth == 0 && maxHeight == 0) {
      Ratio = 1;
    } else if (maxWidth == 0) {
      //
      if (hRatio < 1) Ratio = hRatio;
    } else if (maxHeight == 0) {
      if (wRatio < 1) Ratio = wRatio;
    } else if (wRatio < 1 || hRatio < 1) {
      Ratio = wRatio <= hRatio ? wRatio : hRatio;
    }
    if (Ratio < 1) {
      w = w * Ratio;
      h = h * Ratio;
    }
    objImg.style.height = h + "px";
    objImg.style.width = w + "px";
  },
  // 考虑 IE 的兼容性
  getStyle(el) {
    if (window.getComputedStyle) {
      return window.getComputedStyle(el, null);
    } else {
      return el.currentStyle;
    }
  },
  // 通过当前元素获取宽高
  getWidHei(el, name) {
    let val = name === "width" ? el.offsetWidth : el.offsetHeight,
      which = name === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
    // display is none
    if (val === 0) {
      return 0;
    }
    let style = this.getStyle(el);
    // 左右或上下两边的都减去
    for (let i = 0, a; (a = which[i++]); ) {
      val -= parseFloat(style["border" + a + "Width"]) || 0;
      //val -= parseFloat(style["padding" + a]) || 0;
    }
    return val;
  },
  rand(number) {
    //根据传入的数字生成一个种子随机数
    var today = new Date();
    var seed = today.getTime();
    function rnd() {
      seed = (seed * 9301 + 49297) % 233280;
      return seed / 233280.0;
    }
    return Math.ceil(rnd(seed) * number);
  },
  getProductShareDesc() {
    //拍品作品分享标题
    let arr = [
      "最棒的作品、品相完美、竟然才这么低",
      "超低的价格，绝对的精品！",
      "马上截拍、精品不容错过！",
      "您就说是不是非常厉害！马上结束……"
    ];
    var _this = this;
    return arr[_this.rand(arr.length)];
  },
  Encrypt(word) {
    var key = CryptoJS.enc.Utf8.parse("zsrj00523de6r890");
    var iv = CryptoJS.enc.Utf8.parse("zsrf001d34567890");
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      blockSize: 128,
      sigBytes: 16
    });
    encrypted.blockSize = 128;
    return encrypted.toString();
  },
  //解密
  Decrypt(word, keyStr) {
    keyStr = keyStr ? keyStr : "zsrj00523de6r890";
    var key = CryptoJS.enc.Utf8.parse(keyStr); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    var decrypt = CryptoJS.AES.decrypt(word, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  },
  testIdCard(str) {
    var isIDCard = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
    return isIDCard.test(str) ? true : false;
  },
  getRect(element) {
    var rect = element.getBoundingClientRect();

    var top = document.documentElement.clientTop;

    var left = document.documentElement.clientLeft;

    return {
      top: rect.top - top,

      bottom: rect.bottom - top,

      left: rect.left - left,

      right: rect.right - left
    };
  },
  isNull(str) {
    if (str == "") return true;
    var regu = "^[ ]+$";
    var re = new RegExp(regu);
    return re.test(str);
  },
  isphone(inputString) {
    let myreg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[56]|17[0135678]|18[0-9]|19[89])\d{8}$/;
    console.log(myreg.test(inputString));
    return myreg.test(inputString) ? true : false;
  }
};
//解决遮罩层滚动穿透问题，分别在遮罩层弹出后和关闭前调用
export const modalHelper = function(bodyCls) {
  let scrollTop;
  return {
    afterOpen: function() {
      scrollTop = document.scrollingElement.scrollTop;
      document.body.classList.add(bodyCls);
      document.body.style.top = -scrollTop + "px";
    },
    beforeClose: function() {
      document.body.classList.remove(bodyCls);
      // scrollTop lost after set position:fixed, restore it back.
      document.scrollingElement.scrollTop = scrollTop;
    }
  };
};
export const loadExternalJS = function(arr) {
  if (!(arr && arr.length > 0)) return;
  arr.forEach(src => {
    let script = document.createElement("script");
    let html = document.getElementsByTagName("html")[0];
    script.setAttribute("src", src);
    script.setAttribute("charset", "UTF-8");
    html.appendChild(script);
  });
};
export const loadExternalCSS = function(arr) {
  if (!(arr && arr.length > 0)) return;
  arr.forEach(href => {
    let script = document.createElement("link");
    let html = document.getElementsByTagName("html")[0];
    script.setAttribute("href", href);
    script.setAttribute("rel", "stylesheet");
    html.appendChild(script);
  });
};
export const keyEvent = function(player) {
  let flag = true; //    默认为自动播放
  player.on("playing", msg => {
    // 正在播放
    flag = true;
  });
  player.on("pause", msg => {
    // 暂停播放
    flag = false;
  });

  document.onkeydown = function() {
    let e = event || window.event || arguments.callee.caller.arguments[0];
    let durtion = Number((player.duration() / 60).toFixed(2));
    let currentTime = Number((player.currentTime() / 60).toFixed(2));
    let currentVolume = Number(player.volume().toFixed(2));

    if (e && e.keyCode === 32) {
      // 空格键
      // 暂停
      if (flag) {
        player.pause();
      } else player.play();
    }
    if (e && e.keyCode === 37) {
      // 左
      // 后退
      e.preventDefault();
      if (flag) {
        if (currentTime < durtion) {
          currentTime -= 0.25;
          player.currentTime(currentTime * 60);
        } else {
          player.pause();
        }
      }
    }
    if (e && e.keyCode === 39) {
      // 右
      // 快进
      e.preventDefault();
      if (flag) {
        if (currentTime < durtion) {
          currentTime += 0.25;
          player.currentTime(currentTime * 60);
        } else {
          player.pause();
        }
      }
    }
    if (e && e.keyCode === 38) {
      // 上
      // 音量加
      player.muted(!1);
      if (currentVolume < 1 && currentVolume >= 0) {
        currentVolume += 0.02;
        player.volume(currentVolume);
      }
    }
    if (e && e.keyCode === 40) {
      // 下
      // 音量减
      if (currentVolume <= 1 && currentVolume > 0) {
        currentVolume -= 0.02;
        player.volume(currentVolume);
      }
    }
  };
};
